import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { SessionDataService } from 'src/app/services/session-data.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-elife-subscribe',
  templateUrl: './elife-subscribe.component.html',
  styleUrls: ['./elife-subscribe.component.scss']
})
export class ElifeSubscribeComponent implements OnInit {

  public sku: any;
  public agreedOnterms = false;
  public mobileNumber: any;
  public isExpended: Boolean = false;
  public quantity = 1;
  autoRenew: boolean = false;
  public price: string = '';
  currentAccount: any;
  
  constructor(
    private SKUDS: SkuDataService,
    private UTS: UtilitiesService,
    private ACCS: AccountService,
    private SS: SubjectService
  ) {}

  ngOnInit() {}
  ngDestory() {}
  ngAfterContentInit() {
    const userInfo: any = this.ACCS.getUInfo();

    if (userInfo && userInfo.mainServiceAccountNo) {
      this.SS.currentAccount.subscribe((r) => {
        this.currentAccount = r;
        this.mobileNumber = this.currentAccount.accountNo;
      });
    } else {
      this.SS.account.subscribe((r) => (this.mobileNumber = r));
    }
    this.SS.skuDetails.subscribe((r) => {
      if (r) this.sku = r;
      if (this.sku && this.sku.listPrice) {
        this.getPrice();
      }
    });
  }
  increase() {
    if (this.sku && this.sku.maxQuantity) {
      if (this.sku.maxQuantity > this.quantity) {
        this.quantity++;
        this.getPrice();
      }
    }
  }

  decrease() {
    if (this.sku && this.sku.maxQuantity) {
      if (this.quantity > 1) {
        this.quantity--;
        this.getPrice();
      }
    }
  }
  changeToggle(e: any) {
    this.autoRenew = !this.autoRenew;
  }

  subscribeAddon() {
    const userInfo: any = this.ACCS.getUInfo();
    if (userInfo && userInfo.mainServiceAccountNo) {
      this.SS.subscribeLogin.next(true);
    } else {
      this.addAddon();
    }
  }
  addAddon() {
    let link='/addAddons';
    const payload = {
      accountNo: this.mobileNumber,
      addonId: this.sku.skuId,
      validate: false,
      type: this.autoRenew == true ? 'AUTO_RENEWAL' : 'ONE_TIME',
      quantity: this.quantity,
      specialInputs: [],
      locale: this.UTS.getLocaleLanguage().toString().toLocaleUpperCase(),
    };
    this.SKUDS.addAddons(payload,link).subscribe(
      (r) => {
        this.SS.addonBuySuccessfully.next(true);
      },
      (e) => {
        if (this.UTS.getLocaleLanguage() == 'en') {
          this.UTS.error(e.error.errorDescription);
        } else {
          this.UTS.error(e.error.errorDescriptionAr);
        }
        this.SS.addonBuySuccessfully.next(true);
      }
    );
  }
  getPrice() {
    this.price = Number(Number(this.sku.listPrice) * this.quantity).toFixed(2);
  }

  agreeToggle() {
    this.agreedOnterms = !this.agreedOnterms;
  }

}
